import { Button } from '@ytl/common-web';
import LockedOutImage from '../../assets/lockedout.svg';
import { useLanguage } from '../../contexts/languageContext';
import { useMigration } from './service/MigrationContext';

/**
 * LockoutWebView - Mobile/WebView verzió
 * Megjelenik, ha a felhasználó túl sokszor próbálkozott sikertelenül
 */
export const LockoutWebView = () => {
  const { translation } = useLanguage();
  const { handleReturnToApp } = useMigration();

  return (
    <div
      className="register-page"
      id="migra-lockout-webview"
    >
      <div className="register-page__container">
        <div className="register-page__container__box">
          <div className="migra-webview__character">
            <img
              src={LockedOutImage}
              alt="Locked out"
            />
          </div>
          <h3>{translation.migra.lockout.header}</h3>
          <p>{translation.migra.lockout.description}</p>
          <Button
            variant="contained"
            onClick={handleReturnToApp}
          >
            {translation.migra.lockout.exitButtonWebview}
          </Button>
        </div>
      </div>
    </div>
  );
};
